<template>
  <div
    class="ed-template-description"
    :class="{
      'ed-template-description--expanded': isExpanded,
      'ed-template-description--has-content': hasContent
    }"
  >
    <button
      v-if="editable && !isExpanded && !hasContent"
      type="button"
      class="ed-template-description__add"
      @click="expand"
    >
      <IconInfoCircle
        :width="14"
        :stroke-width="2"
        class="flex-shrink-0"
      />
      <span>{{ t('add_signing_description') }}</span>
    </button>

    <div
      v-else
      class="ed-template-description__box"
    >
      <IconInfoCircle
        :width="16"
        :stroke-width="2"
        class="ed-template-description__icon flex-shrink-0"
      />
      <textarea
        v-if="editable"
        ref="textarea"
        :value="modelValue"
        dir="auto"
        class="ed-template-description__input"
        :placeholder="t('template_description_placeholder')"
        rows="1"
        @input="onInput"
        @focus="isExpanded = true"
        @blur="onBlur"
      />
      <p
        v-else-if="hasContent"
        class="ed-template-description__preview"
      >
        {{ modelValue }}
      </p>
    </div>

    <p
      v-if="editable && isExpanded"
      class="ed-template-description__hint"
    >
      {{ t('signing_description_hint') }}
    </p>
  </div>
</template>

<script>
import { IconInfoCircle } from '@tabler/icons-vue'

export default {
  name: 'TemplateDescription',
  components: {
    IconInfoCircle
  },
  inject: ['t'],
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      isExpanded: !!this.modelValue?.trim(),
      draft: this.modelValue || ''
    }
  },
  computed: {
    hasContent () {
      return !!this.modelValue?.trim()
    }
  },
  watch: {
    modelValue (value) {
      this.draft = value || ''

      if (value?.trim()) {
        this.isExpanded = true
      }

      this.$nextTick(() => this.resizeTextarea())
    }
  },
  mounted () {
    if (this.hasContent) {
      this.$nextTick(() => this.resizeTextarea())
    }
  },
  methods: {
    expand () {
      this.isExpanded = true

      this.$nextTick(() => {
        this.$refs.textarea?.focus()
        this.resizeTextarea()
      })
    },
    onInput (event) {
      this.draft = event.target.value
      this.resizeTextarea()
    },
    onBlur () {
      const value = this.draft.trim()

      if (value !== (this.modelValue || '').trim()) {
        this.$emit('update:model-value', value)
      }

      if (!value) {
        this.isExpanded = false
      }
    },
    resizeTextarea () {
      const textarea = this.$refs.textarea

      if (!textarea) return

      textarea.style.height = 'auto'
      textarea.style.height = `${textarea.scrollHeight}px`
    }
  }
}
</script>
